import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
  import { SwitchItemHeader } from "@/types/SwitchItemHeader";

  interface Props {
    modelValue: SwitchItemHeader | null;
    theme?: string;
    list: SwitchItemHeader[];
    nameRadio?: string;
    slots?: string[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SwitchComponent',
  props: {
    modelValue: { default: null },
    theme: { default: "default" },
    list: { default: () => [] },
    nameRadio: { default: "radio" },
    slots: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const switchItems = ref([]);
  const cssVars = ref({});
  const activeItemIndex = ref(
    props.list.findIndex((item) => item.label === props.modelValue?.label)
  );

  function onChangeItem(item: SwitchItemHeader, index: number) {
    emit("update:modelValue", item);
    activeItemIndex.value = index;
  }
  function changeLineCoords() {
    const activeItem = switchItems.value[activeItemIndex.value];

    if (activeItem) {
      cssVars.value = {
        "--left": (activeItem as HTMLBaseElement).offsetLeft + "px",
        "--width": (activeItem as HTMLBaseElement).scrollWidth + "px",
      };
    }
  }

  onMounted(() => {
    window.addEventListener("resize", changeLineCoords);
  });

  let firstUpdate = true;

  watch(
    () => {
      return props.modelValue;
    },
    () => {
      activeItemIndex.value = props.list.findIndex(
        (item) => item.label === props.modelValue?.label
      );
      setTimeout(changeLineCoords, firstUpdate ? 1000 : 100);
      firstUpdate = false;
    },
    { immediate: true }
  );

const __returned__ = { props, emit, switchItems, cssVars, activeItemIndex, onChangeItem, changeLineCoords, get firstUpdate() { return firstUpdate }, set firstUpdate(v) { firstUpdate = v }, onMounted, ref, watch, get SwitchItemHeader() { return SwitchItemHeader } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})